import { createSlice } from '@reduxjs/toolkit';
import { RootState } from 'redux/store';

/**
 * 初期型
 */
export interface ResourceUrlState {
  resourceUrl: string | null;
}

// 初期状態
export const resourceUrlInitialState: ResourceUrlState = {
  resourceUrl: process.env.NEXT_PUBLIC_RESOURCE_URL ?? null,
};

/**
 * resourceUrlSlice
 */
export const resourceUrlSlice = createSlice({
  name: 'url',
  initialState: resourceUrlInitialState,
  reducers: {},
});

// reducer
export const resourceUrlReducer = resourceUrlSlice.reducer;

/**
 * resourceUrlSelector
 * @param state
 * @returns resourceUrl
 */
export const resourceUrlSelector = (state: RootState) =>
  state.resourceUrl.resourceUrl;
